import RfidMapPicker from "../../Rfid/RfidMapView";

const DEFAULT_MAP_CENTER = { lat: 28.613939, lng: 77.209021 };

const IeComplaintMapView = ({
  latitude,
  longitude,
  location = "",
  height = "320px",
  showDefaultMap = true,
  defaultCenter = DEFAULT_MAP_CENTER,
  locationLoading = false,
  onLocationSelect,
}) => (
  <RfidMapPicker
    latitude={latitude}
    longitude={longitude}
    deviceName="IE Complaint"
    locationLandmark={location}
    height={height}
    showDefaultMap={showDefaultMap}
    defaultCenter={defaultCenter}
    locationLoading={locationLoading}
    onLocationSelect={onLocationSelect}
  />
);

export default IeComplaintMapView;
